module.exports = __webpack_public_path__ + "static/media/assessment-footer-bg.07a8630b.png";